export default __webpack_public_path__ + "static/media/loading.3436d978.gif";